import { ThemeProvider } from "@deere/fuel-react";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App.js";

 ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>, document.getElementById("root")
);


